import * as RA from 'ramda-adjunct';

import { Option } from './option.model';
import { ItemAttributeType } from './enums';

export interface ItemAttribute {

    // todo: migrating to ItemLocale?..
    attributeGroup: string;
    auditInfo: string; // form
    countryCode: string;
    dateUpdated: string;
    description: string;
    jsonProperty: string;
    language: string; // (added to here, so replace this whole type qith ItemLocale?)
    isDirty: boolean; // form
    isOverride: boolean; // old?
    name: string;
    options: Option[];
    required: boolean;
    scope: string; // form
    tag: string;
    type: ItemAttributeType;
    updatedBy: string;
    value: any;
    validationExpression: string;
}

export interface ItemAttributeSummary {
    attribute: string;
    value: string;
}

function getAttributeOrder(): Array<{ tag: string }> {
    // TODO: revisit this
    return [
        { tag: 'POS_ID' },
        { tag: 'RMI' },
        { tag: 'SUB_GROUP_ID' },
        { tag: 'NAME' },
        { tag: 'DESCRIPTION' },
        { tag: '3P_DESCRIPTION' },
        { tag: '3P_TAGLINE' },
        { tag: '3P_IMAGE' },
        { tag: 'MOBILE_IMAGE' },
        { tag: 'DESKTOP_IMAGE' },
        { tag: 'PDP_IMAGES' },
        { tag: 'ITEM_GROUP_TYPE' },
        { tag: 'MEAL' },
        { tag: 'DAY_PART' },
        { tag: 'STATUS' },
        { tag: 'DOT_COM_VISIBLE' },
        { tag: 'ALLOW_SPECIAL_INSTRUCT' },
        { tag: 'BEVERAGE_MODIFIER_TYPE' },
        { tag: 'BEVERAGE_TYPE_GROUPING' },
        { tag: 'POS_NUTRITION_CATEGORY' },
        { tag: 'SERVING_SIZE' },
        { tag: 'VARIATION' },
        { tag: 'ABBREVIATION' },
        { tag: 'SALT_LAW' },
        { tag: 'NUTRITION_FILTERS' },
        { tag: 'IS_EDIBLE' },
        { tag: 'DELIVERY_DISABLED' },
        { tag: 'DELIVERY_METHODS_DISABLED' },
        { tag: 'DISABLED' }
    ];
}

const sortedAttributes: Array<{ tag: string; sortOrder: number }> = getAttributeOrder().map(
    (item, index) => ({
        ...item,
        sortOrder: index + 1000
    })
);

export function getSortedAttributes<T extends { tag: string }>(attributes: T[]): T[] {
    return RA.isNonEmptyArray(attributes)
        ? attributes
            .filter(({ tag }) => tag !== 'TEST_1')
            .map((attribute, index) => {
                const found = sortedAttributes.find(sorted => sorted.tag === attribute.tag);
                return {
                    ...attribute,
                    sortOrder: found ? found.sortOrder : index
                };
            })
            .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
        : [];
}
